import { isRSAA, RSAA } from 'redux-api-middleware';

const createEndpointMiddleware = (getBankId, getApiBaseUrl, getPAASApiBaseUrl) => (store) => (next) => (action) => {
	if (!isRSAA(action)) {
		return next(action);
	}

	const state = store.getState();
	const bankId = getBankId(state, action);
	const apiBaseUrl = getApiBaseUrl(state);
	const apiBaseUrlPaas = getPAASApiBaseUrl(state);

	let nextEndpoint =
		typeof action[RSAA].endpoint === 'function' ? action[RSAA].endpoint(store.getState()) : action[RSAA].endpoint;

	nextEndpoint = nextEndpoint.replace(':bankId', bankId);
	nextEndpoint = nextEndpoint.replace(':scopeId', 'default');
	if (nextEndpoint.indexOf('paas-base-url:') === 0) {
		nextEndpoint = nextEndpoint.replace('paas-base-url:', apiBaseUrlPaas);
	} else {
		nextEndpoint = apiBaseUrl + nextEndpoint;
	}
	const nextAction = {
		[RSAA]: {
			...action[RSAA],
			endpoint: nextEndpoint,
		},
	};

	return next(nextAction);
};

export default createEndpointMiddleware;
